/** yyyy-mm-dd in local time for a given date. */
export const toDateInputValue = (date) => {
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    const d = `${date.getDate()}`.padStart(2, '0');
    return `${y}-${m}-${d}`;
};
/** Default filters: show today onward, all statuses, no search. */
export const defaultAssignmentFilters = (now = new Date()) => ({
    search: '',
    status: 'all',
    from: toDateInputValue(now),
    to: undefined,
});
const lowerBound = (from) => (from ? new Date(`${from}T00:00:00`).getTime() : -Infinity);
const upperBound = (to) => (to ? new Date(`${to}T23:59:59.999`).getTime() : Infinity);
/** Apply all active filters to the assignment list. Pure; safe to memoize. */
export const filterAssignments = (events, filters) => {
    const search = filters.search.trim().toLowerCase();
    const from = lowerBound(filters.from);
    const to = upperBound(filters.to);
    return events.filter((event) => {
        if (filters.status !== 'all' && event.status !== filters.status) {
            return false;
        }
        if (search && !event.title.toLowerCase().includes(search) && !event.id.toLowerCase().includes(search)) {
            return false;
        }
        // Range membership is an interval-overlap test, not a start-only test: an assignment belongs in
        // [from, to] when its availability window [start, end] overlaps that range. Using start alone
        // wrongly hides an assignment that began before `from` but is still active within the range (e.g.
        // a multi-day diary that started before today but has an event today under the default today-onward
        // view). end falls back to start for point-in-time events.
        const start = new Date(event.start).getTime();
        const end = new Date(event.end ?? event.start).getTime();
        if (start > to || end < from) {
            return false;
        }
        // A forward-looking range (the default `from` = today) is about work still ahead: an
        // already-completed assignment whose window opened before `from` is finished business, not
        // upcoming, so exclude it even if its end date happens to fall in the future. Missed/past events
        // are already excluded above by `end < from`. Clearing/lowering `from` keeps completed history
        // because `from` then sits at/before those starts.
        if (event.status === 'completed' && start < from) {
            return false;
        }
        return true;
    });
};
